<p>input-date works!</p>
